/* eslint-disable */
// @ts-nocheck

import pyramidUk from './data/pyramid-uk.js';
import pyramidAu from './data/pyramid-au.js';
import bar from './data/bar.js';
import line from './data/line.js';
import stackedBar from './data/stacked-bar.js';
import horizontalBar from './data/horizontal-bar.js';


export const registry = {
  'pyramid-uk': { key: 'pyramid-uk', label: 'Pyramid', data: pyramidUk },
  'pyramid-au': { key: 'pyramid-au', label: 'Aus Pyramid', data: pyramidAu },
  'bar': { key: 'bar', label: 'Bar', data: bar },
  'stacked-bar': { key: 'stacked-bar', label: 'Stacked Bar', data: stackedBar },
  'horizontal-bar': { key: 'horizontal-bar', label: 'Horizontal Bar', data: horizontalBar },
  'line': { key: 'line', label: 'Line', data: line },
};

export const registryOptions = Object.keys(registry).map((key) => ({ key, label: registry[key].label }));

export function getEntry(key) {
  const entry = registry[key];
  return entry;
}